import { RumInitConfiguration } from '@datadog/browser-rum';

export const emptyDatiqDatadogRumConfig: Omit<RumInitConfiguration, 'clientToken' | 'applicationId'> = {
    site: 'datadoghq.com',
    service: 'dat-iq',
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['feature_flags']
};